import type { FormFields } from './form.types';

export const REQUIRED_FIELDS = ['numberOfPets', 'totalCupsPerDay'] as const;

export const EMPTY_FORM_VALUES: FormFields = {
    numberOfPets: '',
    totalCupsPerDay: '',
};

export const FORM_FIELD_OPTIONS = {
    shouldDirty: true,
    shouldValidate: true,
} as const;

export const NUMBER_OF_PETS_VALUES = Array.from({ length: 5 }, (_, index) => String(index + 1));

export const NUMBER_OF_PETS_ITEMS = NUMBER_OF_PETS_VALUES.map(value => ({ label: value, value }));

export const CUPS_UNIT_SUFFIX = ' cups';
const NUMERIC_CUPS_PATTERN = /^\d+(\.\d+)?$/;

// Numbers only, up to 1 decimal place (e.g. "2", "2.5")
export const CUPS_DECIMAL_PATTERN = /^\d+(\.\d)?$/;

export const CUPS_MIN_VALUE = 0.5;
export const CUPS_MAX_VALUE = 20;

export function formatCupsAmount(value: string): string {
    const trimmed = value.trim();
    if (!NUMERIC_CUPS_PATTERN.test(trimmed)) {
        return trimmed;
    }

    const numericValue = Number(trimmed);
    if (!Number.isFinite(numericValue)) {
        return trimmed;
    }

    return String(numericValue);
}

export function formatCupsWithUnit(value: string): string {
    const amount = formatCupsAmount(value);
    if (!amount) {
        return amount;
    }

    return `${amount}${CUPS_UNIT_SUFFIX}`;
}

export function isInvalidNonEmptyTotalCupsPerDay(value: string): boolean {
    const trimmed = value.trim();
    if (!trimmed) {
        return false;
    }

    const isValidFormat = CUPS_DECIMAL_PATTERN.test(trimmed);
    const numericValue = Number(trimmed);
    const isHalfCupIncrement = Number.isInteger(numericValue * 2);

    return !isValidFormat || numericValue < CUPS_MIN_VALUE || numericValue > CUPS_MAX_VALUE || !isHalfCupIncrement;
}

// Autocomplete suggestions in 0.5 increments, e.g. "0.5 cups" ... "20 cups".
export const CUPS_SUGGESTIONS = Array.from(
    { length: (CUPS_MAX_VALUE - CUPS_MIN_VALUE) / 0.5 + 1 },
    (_, index) => `${CUPS_MIN_VALUE + index * 0.5}${CUPS_UNIT_SUFFIX}`
);
